import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationPaymentTrackDto extends EpimsBaseEntityDto {


   OwnerType: string;
   ObligationPeriod: string;
   TotalAcreage: number;
   Unit: string;
   TotalAmount: number;
   UomRate: number;
   Description: string;
   FromDate: Date;
   ToDate: Date;
   CreatedBy: string;
   LandTitleId: string;
   SubscriptionUserId: string;
   Status: string;
   ApprovalStatus: string;
   LandUom: string;
   PaymentStatus: string;
   ReminderDays: string;
   ReminderEmail: string;
   Remarks: string;
   Years: string;
   Days: string;
   Rate: string;
   TerrainId: string;
   RightsPaymentSummaryId: string;
   BulkPaymentHistoryId: string;
   Amount: number;
}
